import axios from '@/utils/axios'

export const getSupplier = (payload) => {
    return axios.get('/supplier', {
        params: payload
    })
}

export const createSupplier = (data) => {
    return axios.post('/supplier', data)
}

export const getSupplierById = (id) => {
    return axios.get(`/supplier/${id}`)
}

export const updateSupplier = (id, data) => {
    return axios.put(`/supplier/${id}`, data)
}

export const deleteSupplier = (id) => {
    return axios.delete(`/supplier/${id}`)
}